<div class="footer">
  <div class="content-container">
    <div class="ui-g">
      <div class="ui-g-3 ui-sm-12 ui-md-6 ui-lg-4 text-left m-b-30">
        <div class="header">
          {{ 'FOOTER.NAVIGATION.TITLE' | translate }}
        </div>
        <ul>
          <li>
            <a href="/data">{{ 'FOOTER.NAVIGATION.DATA_PORTAL' | translate }}</a>
          </li>
          <li>
            <a href="https://support.scout.org">{{'FOOTER.NAVIGATION.SUPPORT' | translate }}</a>
          </li>
          <li>
            <a href="/contacts">{{ 'FOOTER.NAVIGATION.DASHBOARD' | translate }}</a>
          </li>
          <li *gsShowIfHasPermission="['WSD_PERSON_CREATE']">
            <a href="/persons/create">{{ 'FOOTER.NAVIGATION.CREATE_PERSON' | translate }}</a>
          </li>
          <li *gsShowIfHasPermission="['WSD_ORGANIZATION_CREATE']">
            <a href="/organizations/create">{{ 'FOOTER.NAVIGATION.CREATE_ORGANIZATION' | translate }}</a>
          </li>
          <li *gsShowIfHasPermission="['WSD_CLASSIFICATIONS_READ']">
            <a href="/administration">{{ 'FOOTER.NAVIGATION.CLASSIFICATIONS' | translate }}</a>
          </li>
          <li *gsShowIfHasPermission="['WSD_USER_ROLES_READ']">
            <a href="/user-roles">{{ 'FOOTER.NAVIGATION.USER_ROLES' | translate }}</a>
          </li>
          <li *gsShowIfHasPermission="['WSD_NOTIFICATIONS_READ']">
            <a href="/notifications">{{ 'FOOTER.NAVIGATION.NOTIFICATIONS' | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="ui-g-3 ui-sm-12 ui-md-6 ui-lg-4 text-left m-b-30">
        <div class="header">
          <a href="/notifications">{{ 'FOOTER.LEGAL.TITLE' | translate }}</a>
        </div>
        <ul>
<!--          <li>-->
<!--            <a href="https://www.scout.org/node/6924" target='_new'>{{ 'FOOTER.LEGAL.TAC' | translate }}</a>-->
<!--          </li>-->
          <li>
            <a href="https://scout.org/cookies-policy" target='_new'>{{ 'FOOTER.LEGAL.COOKIES_POLICY' | translate }}</a>
          </li>
          <li>
            <a href="https://scout.org/privacy" target='_new'>{{ 'FOOTER.LEGAL.PRIVACY_POLICY' | translate }}</a>
          </li>
<!--          <li>-->
<!--            <a href="https://www.scout.org/copyright" target='_new'>{{ 'FOOTER.LEGAL.TERMS_OF_USE' | translate }}</a>-->
<!--          </li>-->
          <li>
            <a href="https://scout.org/child-online-protection-guidelines" target='_new'>{{ 'FOOTER.LEGAL.CHILD_PROTECTION' | translate }}</a>
          </li>
          <li>
            <a href=" https://learn.scout.org/resource/wosm-complaints-policy" target='_new'>{{ 'FOOTER.LEGAL.COMPLAINTS_POLICY' | translate }}</a>
          </li>
<!--          <li>-->
<!--            <a href="https://www.scout.org/gsat" target='_new'>{{ 'FOOTER.LEGAL.QUALITY_STANDARDS' | translate }}</a>-->
<!--          </li>-->
        </ul>
      </div>
      <div class="ui-g-3 ui-sm-12 ui-md-12 ui-lg-4 text-center">
        <img style="width: 100%; max-width: 371px;" src="https://www.scout.org/sites/all/themes/custom/worldscout/images/ScoutFooterLogo.png">
      </div>
    </div>
  </div>
</div>
